module.exports = __webpack_public_path__ + "img/88009030000371.a98e5dbe.png";